import { useRef, useState } from "react";
import { NewFirebaseUser, getUserData, rdbSetKakUserSource, rdbUpdateKakVerifyDate, serverAddUser, serverHelloWorld, serverTest, serverUidExists } from "../../../store/firebaseStore";
import { delayFunction, getSwedishDate } from "../../../utils/utils";


export type NewFirebaseUserExt = NewFirebaseUser & { existsDb: boolean, existsAuth: boolean, kakSource: string };

export function ImportUsersView() {
    // const location: LocationModel = useStoreState<AppModel>((state) => state.location);
    // const userdata: UserDataModel = useStoreState<AppModel>((state) => state.userdata);
    // const contentuser: ContentUserModel = useStoreState<AppModel>((state) => state.contentUser);
    // const loadMethod: ActionCreator<void> = useStoreActions<AppModel>((actions) => actions.content.loadContent);
    // useEffect(()=>{
    // }, []);

    const textareaRef = useRef<HTMLTextAreaElement | null>(null);
    const [newUsers, setNewUsers] = useState<NewFirebaseUserExt[]>([]);
    const [progress, setProgress] = useState<{ idx: number, count: number }>({ idx: 0, count: 0 });

    const importUsers = async () => {
        const text = textareaRef.current?.value;
        if (!text) return;
        const lines: string[] = text.split('\n');
        const newUsers: NewFirebaseUserExt[] = [];
        lines.map(line => {
            const fields: string[] = line.split('\t');
            const user: ImportUser = {
                uid: fields[0],
                ssnr: fields[1],
                lastname: fields[2],
                firstname: fields[3],
                email: fields[4],
                source: fields[5],
            }
            const date = new Date();
            const dateString = date.toLocaleDateString('sv-SE', { month: '2-digit', day: '2-digit', year: 'numeric' });
            const newUser: NewFirebaseUserExt = {
                uid: user.uid,
                email: user.email,
                password: 'Stenhammar',
                kakVerifyDate: dateString,
                userdata: {
                    firstName: user.firstname,
                    lastName: user.lastname,
                    claims: {
                        accesses: [{ access: 1, id: 'kak' }],
                        current: { access: 1, id: 'kak' }
                    }
                },
                kakSource: user.source,
                existsAuth: false,
                existsDb: false,
                // dbKakSource: 'XXXXXX',
            }
            newUsers.push(newUser);
            setNewUsers(newUsers);
        });
        setProgress({ idx: 0, count: newUsers.length });
    }

    const checkUsers = async () => {
        let idx = 0;
        setProgress({ idx: 0, count: 0 });
        for (let newUser of newUsers) {
            idx++;
            setProgress({ idx: idx, count: newUsers.length });
            console.log(newUser.uid);

            // hämta data från user-tabellen
            const dbData = await getUserData(newUser.uid);

            // hämta data från auth-lösningen
            const authData = await serverUidExists(newUser.uid);


            newUser.existsDb = dbData ? true : false;
            if (dbData) {
                newUser.kakVerifyDate = dbData.kakVerifyDate;
            }

            newUser.existsAuth = authData.data ? true : false;
        }
        // console.log('setNewUsers', newUsers.length);
        setNewUsers([...newUsers]);

    }

    const tagOld = async () => {
        const text = textareaRef.current?.value;
        if (!text) return;
        const lines: string[] = text.split('\n');
        const newUsers: NewFirebaseUserExt[] = [];

        for (let line of lines) {
            const fields: string[] = line.split('\t');
            const uid = fields[0];
            const kaksource = fields[5];
            console.log(uid, kaksource);
            // await rdbSetKakUserSource(uid, kaksource);
        }
    }

    return <>
        <h3> ImportUsersView</h3>
        <p>Progress: {progress.idx} / {progress.count}</p>
        <p>current date: {getSwedishDate()}</p>
        <textarea ref={textareaRef} style={{ fontSize: "70%", minHeight: "10rem" }}></textarea>
        <div className="Flex FlexColumn Pad05">
            <button onClick={async e => {
                await importUsers();
            }}>Importera användare från SYNC-fliken</button >
            <button onClick={e => { checkUsers(); }}>Kontrollera användarnas status ({progress.idx} / {progress.count})</button>
            {/* <button onClick={e => { tagOld() }}>Tag old</button> */}
        </div >
        <p>Antal användaridentiteter: {newUsers.length}</p>
        {
            newUsers.map((user, index) => <ImportUserItem key={index} verifyDate={getSwedishDate()} user={user} onUserChange={(user: NewFirebaseUserExt) => {
                console.log('user updated!');
                setNewUsers([...newUsers]);
            }} />)
        }
    </>
}

export type ImportUser = {
    uid: string,
    ssnr: string
    lastname: string,
    firstname: string,
    email: string,
    source: string,
}

function ImportUserItem(props: { user: NewFirebaseUserExt, verifyDate: string, onUserChange: (user: NewFirebaseUserExt) => void }) {
    const { user } = props;
    return <div className="Flex">

        {(!props.user.existsDb && !props.user.existsAuth) &&
            <button onClick={e => {
                serverAddUser(user).then(response => {
                    console.log('User added', response);
                    props.user.existsAuth = true;
                    props.user.existsDb = true;
                    props.onUserChange(props.user);
                }).catch(err => {
                    alert('Error: ' + err);
                });
            }}>Create</button>}

        {/* <p>{user.uid}</p> */}

        {!checkDate(props.verifyDate, user.kakVerifyDate) &&
            <button onClick={async e => {
                user.kakVerifyDate = props.verifyDate;
                await rdbUpdateKakVerifyDate(user.uid, props.verifyDate);
                props.onUserChange(user);

            }}>Uppdatera</button>
        }

        <p className={user.existsDb ? checkColor(checkDate(props.verifyDate, user.kakVerifyDate)) : 'Pill BGDogdgerBlue'}>{user.kakVerifyDate}</p>
        <div className="Flex FlexColumn Gap0" style={{ fontSize: '80%' }}>
            <div className="Flex">
                <p><strong>{user.userdata.lastName}</strong></p>
                <p><strong>{user.userdata.firstName}</strong></p>
            </div>
            <div className="Flex">
                <p>{user.email}</p>
                <p>{user.kakSource}</p>
            </div>
        </div>
        {/* <p>{user.dbKakSource}</p> */}
        <p className={checkColor(user.existsAuth)}>Auth</p>
        <p className={checkColor(user.existsDb)}>Database</p>
    </div >
}

const checkColor = (i: boolean) => i ? 'Pill BGLime' : 'Pill BGTomato';

const checkDate = (date1: string, date2: string | null) => {
    if (date2 === null) return false;
    const d1 = new Date(date1);
    const d2 = new Date(date2);
    return d1.getTime() === d2.getTime();
}


